// SPDX-License-Identifier: MIT
// /connecter — "La façon Terminal" journey. Ported from the operator-approved mockup
// /__mock/terminal-journey-v3/ (the mockup IS the component). Explains the REAL
// terminal flow that was missing : install ONCE (your Claude = inference, your
// Genesis account = credits, project-scoped MCP — never your other sessions), then
// you CONVERSE (not a terminal of commands) and your Claude builds + ships. Ideas
// are counted via the Genesis MCP (terminal pack, cheaper BYOAI) ; Cloud = an account
// subscription, browser-redirect to subscribe — never billed in the terminal.
// Bilingual via a local dict (large standalone section, like exemples.ts/compte.ts).
import { detectLocale } from '../i18n/detect';
import { escapeHtml as esc } from '../lib/escape';

const STR = {
  fr: {
    kicker: '② La façon Terminal',
    h1a: 'Tu installes', h1aEm: 'une fois', h1b: 'Après, tu', h1bEm: 'parles',
    lead: 'Le « terminal », c\'est 3 minutes de setup au début. Ensuite tu ne tapes plus de commandes — tu <em>converses</em> avec ton Claude, et il construit, commit, déploie. Même les devs ne codent plus. 🙂',
    byoai: '// ton abonnement Claude = l\'inférence (à toi, en local, souverain 🇫🇷) · Genesis ne voit jamais ton compte Claude',
    step1: '01 — une seule fois', s1h: 'Branche ton', s1hEm: 'Claude', s1hb: '+ ton', s1hbEm: 'compte',
    s1sub: 'Deux liens, une fois pour toutes. Après, tu n\'y reviens plus.',
    cardAh: '① Ton Claude (l\'inférence)', cardAp: 'Installe Claude Code, connecte ton abo Pro/Max.',
    cardBh: '② Ton compte Genesis (tes crédits)', cardBp: 'Au 1ᵉʳ projet, ton navigateur s\'ouvre une fois :',
    browser: '🔗 « Connect my Claude » → <b>Autoriser</b><br>→ compte lié (crédits + sync web↔terminal)',
    pin: '↑ Genesis vit DANS ton projet (.claude/) — jamais dans tes autres sessions Claude ✓',
    gemKicker: '✦ la perle',
    gemH: 'Le serveur Genesis', gemHEm: 'que ton Claude appelle',
    gemBody: 'Genesis n\'est pas une app de plus à ouvrir. C\'est un <b>serveur</b> que TON Claude appelle — <b>sans inférence</b> : il ne magnifie pas (ça, c\'est ton Claude), il lui donne <b>la recette</b> (la méthode), <b>persiste la fiche</b>, et <b>bootstrappe ton repo</b>. Invisible dans le terminal, mais c\'est lui qui transforme « code-moi un truc » en <b>un vrai projet Genesis</b>. Ton Claude est l\'artisan ; Genesis lui donne la méthode + la mémoire.',
    gemTools: ['get_recipe', 'save_manifest', 'save_discovery', 'get_project_state', 'forgejo_bootstrap', 'link_supabase_byo'],
    tool2: '✦ genesis · get_recipe → save_manifest', tool6: '✦ genesis · forgejo_bootstrap',
    step2: '02 — à chaque idée', s2h: 'Ouvre ton projet, et', s2hEm: 'parle',
    s2sub: 'Tu lances <code>claude</code> dans ton dossier — le serveur Genesis du projet se connecte tout seul. Vérifie avec <code>/mcp</code>. Après, ce n\'est plus un terminal, c\'est une conversation.',
    launchCmd: '~/sante-parents $ claude', launchOk: '> /mcp',
    launchTools: '✓ genesis — connecté · 6 outils',
    launchReady: 'get_recipe · save_manifest · save_discovery · get_project_state · forgejo_bootstrap · link_supabase_byo',
    launchNote: '↑ le serveur Genesis du projet est branché — ses 6 outils sont dispo pour ton Claude ↑',
    chatTitle: 'claude · sante-parents/ · ✦ genesis (ce projet)',
    m1: 'Une app pour suivre la santé de mes parents — médicaments, rendez-vous, simple.',
    who1: '✦ ton Claude + Genesis',
    m2: 'Je lis la recette Genesis, je magnifie ton idée moi-même (mon inférence) → voici la fiche, et je la sauve. Puis je code l\'écran d\'accueil + la liste des médocs. 🪄',
    did2: '✓ get_recipe · save_manifest (projet créé) · 1er écran', credit2: '−1 idée · pack terminal',
    m3: 'Ajoute un rappel pour chaque prise.', who3: '✦ ton Claude',
    m4: 'Fait — écran de rappels + notifs. Je commit.', did4: '✓ codé · testé · git commit',
    m5: 'Parfait. Mets-la en ligne.', who5: '✦ ton Claude',
    m6: 'Je crée + pousse ton repo (privé : admin + toi). Pour l\'hébergement Cloud, j\'ouvre ton navigateur pour activer l\'abo… ✓ → en ligne :<br><b>sante-parents.exemple.com</b>',
    did6: '✓ forgejo_bootstrap (repo privé) · Cloud via navigateur · en ligne',
    nocode: '↑ tu n\'as tapé aucune commande — tu as juste dit ce que tu voulais ↑',
    modelH: 'en clair, le modèle',
    model1: '<b>Une idée magnifiée = 1 crédit</b> (pack <b>terminal</b> — moins cher que le web : tu apportes ton Claude). Comptée à <code>save_manifest</code>. 1ʳᵉ idée offerte.',
    model2: '<b>Ton repo reste privé</b> (admin Genesis + ton email) — tu ajoutes qui tu veux par email. Code versionné via <code>forgejo_bootstrap</code>.',
    model3: '<b>Le Cloud (en ligne 24/7) = un abo sur ton compte</b> : « mets-la en ligne » → Genesis t\'ouvre le navigateur pour t\'abonner. Le paiement n\'est jamais dans le terminal.',
    model4: '<b>Idées illimitées ?</b> Le logiciel <b>Desktop à vie</b> les débloque.',
    shipH: 'Prêt à', shipHEm: 'brancher ton Claude', shipHb: '?',
    shipP: 'Le setup guidé pas à pas. Après, tu n\'auras plus qu\'à parler.', shipCta: 'Connecter mon Claude ↓',
  },
  en: {
    kicker: '② The Terminal way',
    h1a: 'You install', h1aEm: 'once', h1b: 'Then, you', h1bEm: 'talk',
    lead: 'The "terminal" is 3 minutes of setup up front. After that you stop typing commands — you <em>converse</em> with your Claude, and it builds, commits, ships. Even devs don\'t code anymore. 🙂',
    byoai: '// your Claude subscription = the inference (yours, local, sovereign 🇫🇷) · Genesis never sees your Claude account',
    step1: '01 — just once', s1h: 'Connect your', s1hEm: 'Claude', s1hb: '+ your', s1hbEm: 'account',
    s1sub: 'Two links, once and for all. You never come back to it.',
    cardAh: '① Your Claude (the inference)', cardAp: 'Install Claude Code, connect your Pro/Max plan.',
    cardBh: '② Your Genesis account (your credits)', cardBp: 'On the 1st project, your browser opens once:',
    browser: '🔗 "Connect my Claude" → <b>Authorize</b><br>→ account linked (credits + web↔terminal sync)',
    pin: '↑ Genesis lives INSIDE your project (.claude/) — never in your other Claude sessions ✓',
    gemKicker: '✦ the gem',
    gemH: 'The Genesis server', gemHEm: 'your Claude calls',
    gemBody: 'Genesis isn\'t one more app to open. It\'s a <b>server</b> YOUR Claude calls — <b>inference-free</b>: it doesn\'t magnify (that\'s your Claude), it hands it <b>the recipe</b> (the method), <b>persists the sheet</b>, and <b>bootstraps your repo</b>. Invisible in the terminal, but it\'s what turns "code me something" into <b>a real Genesis project</b>. Your Claude is the craftsman; Genesis hands it the method + the memory.',
    gemTools: ['get_recipe', 'save_manifest', 'save_discovery', 'get_project_state', 'forgejo_bootstrap', 'link_supabase_byo'],
    tool2: '✦ genesis · get_recipe → save_manifest', tool6: '✦ genesis · forgejo_bootstrap',
    step2: '02 — for every idea', s2h: 'Open your project, and', s2hEm: 'talk',
    s2sub: 'You run <code>claude</code> in your folder — the project\'s Genesis server connects on its own. Check with <code>/mcp</code>. After that, it\'s not a terminal anymore, it\'s a conversation.',
    launchCmd: '~/parents-health $ claude', launchOk: '> /mcp',
    launchTools: '✓ genesis — connected · 6 tools',
    launchReady: 'get_recipe · save_manifest · save_discovery · get_project_state · forgejo_bootstrap · link_supabase_byo',
    launchNote: '↑ the project\'s Genesis server is wired in — its 6 tools are available to your Claude ↑',
    chatTitle: 'claude · parents-health/ · ✦ genesis (this project)',
    m1: 'An app to track my parents\' health — meds, appointments, simple.',
    who1: '✦ your Claude + Genesis',
    m2: 'I read the Genesis recipe, magnify your idea myself (my inference) → here\'s the sheet, and I save it. Then I code the home screen + the meds list. 🪄',
    did2: '✓ get_recipe · save_manifest (project created) · 1st screen', credit2: '−1 idea · terminal pack',
    m3: 'Add a reminder for each dose.', who3: '✦ your Claude',
    m4: 'Done — reminders screen + notifs. Committing.', did4: '✓ coded · tested · git commit',
    m5: 'Perfect. Put it online.', who5: '✦ your Claude',
    m6: 'I create + push your repo (private: admin + you). For Cloud hosting, I\'m opening your browser to activate the plan… ✓ → live:<br><b>parents-health.example.com</b>',
    did6: '✓ forgejo_bootstrap (private repo) · Cloud via browser · live',
    nocode: '↑ you typed zero commands — you just said what you wanted ↑',
    modelH: 'the model, plainly',
    model1: '<b>One magnified idea = 1 credit</b> (<b>terminal</b> pack — cheaper than web: you bring your Claude). Counted at <code>save_manifest</code>. 1st idea free.',
    model2: '<b>Your repo stays private</b> (Genesis admin + your email) — you add whoever you want by email. Code versioned via <code>forgejo_bootstrap</code>.',
    model3: '<b>Cloud (online 24/7) = a subscription on your account</b>: "put it online" → Genesis opens your browser to subscribe. Payment is never in the terminal.',
    model4: '<b>Unlimited ideas?</b> The <b>lifetime Desktop</b> app unlocks them.',
    shipH: 'Ready to', shipHEm: 'connect your Claude', shipHb: '?',
    shipP: 'The guided setup, step by step. After that, you just talk.', shipCta: 'Connect my Claude ↓',
  },
} as const;

export function renderTerminalJourney(): HTMLElement {
  const S = STR[detectLocale() === 'en' ? 'en' : 'fr'];
  const el = document.createElement('section');
  el.className = 'tj';
  el.setAttribute('data-component', 'terminal-journey');
  const msg = (side: 'you' | 'ai', html: string, who = '', did = '', credit = '', tool = '') => `
    <div class="tj-msg tj-msg--${side}"><div class="tj-bubble">
      ${who ? `<span class="tj-who">${esc(who)}</span>` : ''}${tool ? `<span class="tj-tool">${esc(tool)}</span>` : ''}${html}
      ${did ? `<span class="tj-did">${esc(did)}</span>` : ''}${credit ? `<span class="tj-credit">${esc(credit)}</span>` : ''}
    </div></div>`;
  el.innerHTML = `
    <p class="tj-kicker">${esc(S.kicker)}</p>
    <h1 class="tj-h1">${esc(S.h1a)} <em>${esc(S.h1aEm)}</em>.<br>${esc(S.h1b)} <em>${esc(S.h1bEm)}</em>.</h1>
    <p class="tj-lead">${S.lead}</p>
    <p class="tj-byoai">${esc(S.byoai)}</p>

    <span class="tj-stepnum">${esc(S.step1)}</span>
    <h2 class="tj-h2">${esc(S.s1h)} <em>${esc(S.s1hEm)}</em> ${esc(S.s1hb)} <em>${esc(S.s1hbEm)}</em></h2>
    <p class="tj-sub">${esc(S.s1sub)}</p>
    <div class="tj-setup">
      <div class="tj-scard"><h3>${esc(S.cardAh)}</h3><p>${esc(S.cardAp)}</p>
        <div class="tj-term"><span class="c">npm</span> i -g @anthropic-ai/claude-code<br><span class="c">claude</span> login</div></div>
      <div class="tj-scard"><h3>${esc(S.cardBh)}</h3><p>${esc(S.cardBp)}</p>
        <div class="tj-browser">${S.browser}</div></div>
    </div>
    <p class="tj-pin">${esc(S.pin)}</p>

    <div class="tj-gem">
      <span class="tj-gem__glow" aria-hidden="true"></span>
      <p class="tj-gem__kicker">${esc(S.gemKicker)}</p>
      <h2 class="tj-gem__h">${esc(S.gemH)} <em>${esc(S.gemHEm)}</em></h2>
      <p class="tj-gem__body">${S.gemBody}</p>
      <div class="tj-gem__tools">${S.gemTools.map((x) => `<span class="tj-gem__tool">${esc(x)}</span>`).join('')}</div>
    </div>

    <span class="tj-stepnum">${esc(S.step2)}</span>
    <h2 class="tj-h2">${esc(S.s2h)} <em>${esc(S.s2hEm)}</em></h2>
    <p class="tj-sub">${S.s2sub}</p>
    <div class="tj-launch">
      <span class="tj-launch__cmd">${esc(S.launchCmd)}</span>
      <span class="tj-launch__ok">${esc(S.launchOk)}</span>
      <span class="tj-launch__tools">${esc(S.launchTools)}</span>
      <span class="tj-launch__ready">${esc(S.launchReady)}</span>
    </div>
    <p class="tj-launchnote">${esc(S.launchNote)}</p>
    <div class="tj-chat">
      <div class="tj-chat__bar"><span class="tj-dot" style="background:var(--orange,#ff7043)"></span><span class="tj-dot" style="background:#f0a500"></span><span class="tj-dot" style="background:#9bc995"></span><span class="tj-chat__title">${esc(S.chatTitle)}</span></div>
      ${msg('you', esc(S.m1))}
      ${msg('ai', esc(S.m2), S.who1, S.did2, S.credit2, S.tool2)}
      ${msg('you', esc(S.m3))}
      ${msg('ai', esc(S.m4), S.who3, S.did4)}
      ${msg('you', esc(S.m5))}
      ${msg('ai', S.m6, S.who5, S.did6, '', S.tool6)}
    </div>
    <p class="tj-nocode">${esc(S.nocode)}</p>

    <div class="tj-model">
      <h4>${esc(S.modelH)}</h4>
      <ul><li>${S.model1}</li><li>${S.model2}</li><li>${S.model3}</li><li>${S.model4}</li></ul>
    </div>

    <div class="tj-ship">
      <div><h3>${esc(S.shipH)} <em>${esc(S.shipHEm)}</em> ${esc(S.shipHb)}</h3><p>${esc(S.shipP)}</p></div>
      <a class="tj-ship__cta" href="#connect-claude-stepper" data-component="tj-cta">${esc(S.shipCta)}</a>
    </div>
  `;
  // CTA scrolls down to the actual connect stepper (renderConnectClaude) below.
  el.querySelector<HTMLAnchorElement>('[data-component="tj-cta"]')?.addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector('.connect-claude')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  return el;
}
